import styled from "styled-components";
import { Switch } from "antd";

export const SwitchWrapper = styled(Switch)`
  &[class~="ant-switch-checked"] {
    background-color: var(--primary-red-color);
  }
`;
